module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "messageListCheerSettingContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "cheerBackgroundBoard"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "messageListCheerSettingMenu"
    }
  }, [_c('div', {
    attrs: {
      "id": "menuCloseCheerButton"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _vm._l((_vm.cheerMenuItem), function(menu, index) {
    return _c('div', {
      key: index,
      staticClass: "settingMenu"
    }, [_c('div', {
      staticClass: "settingMenuTitle"
    }, [_vm._v(_vm._s(menu.menuTitle))]), _vm._v(" "), _c('form', _vm._l((menu.items), function(item, index) {
      return (item.valueName === 'cheerMessage') ? _c('div', {
        key: index,
        staticClass: "settingMenuItem"
      }, _vm._l((item.values), function(value, index) {
        return _c('div', {
          key: index
        }, [_c('label', {
          attrs: {
            "for": ("cheer_" + (value.value))
          }
        }, [_c('input', {
          staticClass: "settingMenuItemValue",
          attrs: {
            "id": ("cheer_" + (value.value)),
            "type": [item.valueName === 'cheerMessage' ? 'radio' : 'checkbox'],
            "name": "cheer"
          },
          domProps: {
            "value": value.value,
            "checked": value.selected
          },
          on: {
            "click": function (e) { return _vm.updateSettingValue(e, item.valueName); }
          }
        }), _vm._v("\n              " + _vm._s(value.name) + "\n            ")])])
      }), 0) : _vm._e()
    }), 0)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7988ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-message-cheer-setting.vue
// module id = 104
// module chunks = 0